import FontDownloadOutlinedIcon from "@mui/icons-material/FontDownloadOutlined";
import TextFormatRoundedIcon from "@mui/icons-material/TextFormatRounded";
import IconButton from "@mui/material/IconButton";
import React, {useMemo} from "react";
import {editorHasContent} from "components/common/TextAreaEditor";

const styles = {
    root: {
        fontFamily: "'Georgia', serif",
        fontSize: 14,
        padding: 20,
        width: 600,
    },
    editor: {
        borderTop: "1px solid #ddd",
        cursor: "text",
        fontSize: 16,
        marginTop: 20,
        minHeight: 400,
        paddingTop: 20,
    },
    controls: {
        fontFamily: "'Helvetica', sans-serif",
        fontSize: 14,
        marginBottom: 10,
        userSelect: "none",
    },
    styleButton: {
        marginRight: 3,
    },
};
const COLORS = [
    { label: "Black", style: "black" },
    { label: "Red", style: "red" },

    { label: "Yellow", style: "yellow" },
    { label: "Green", style: "green" },
];
export const COLOR_STYLE_MAP = {
    black: {
        color: "black",
    },
    red: {
        color: "rgb(255, 0, 0)",
    },

    yellow: {
        color: "rgb(180, 180, 0)",
    },
    green: {
        color: "rgb(0, 180, 0)",
    },
};
class StyleColorButton extends React.Component {
    constructor(props) {
        super(props);
        this.onToggle = (e) => {
            e.preventDefault();
            this.props.onToggle(this.props.style);
        };
    }

    render() {
        let style;
        const { readOnly, active, index } = this.props;
        const color = COLOR_STYLE_MAP[this.props.style];
        style = { fontSize: 20, ...color };
        if (active) {
            style.opacity = 1;

            style.color = color.color;
        }

        const btnSty = { ...styles.styleButton };
        if (index === 0) {
            btnSty.marginLeft = 20;
        }
        return (
            <IconButton disabled={readOnly} size={"small"} style={btnSty}>
                {active ? (
                    <FontDownloadOutlinedIcon style={style} onMouseDown={this.onToggle} />
                ) : (
                    <TextFormatRoundedIcon style={style} onMouseDown={this.onToggle} />
                )}
            </IconButton>
        );
    }
}

export function ColorControls({ editorState, onToggle }) {
    const hasContent = useMemo(() => {
        return editorHasContent(editorState);
    }, [ editorState]);
    const currentStyle = hasContent ?  editorState.getCurrentInlineStyle() : null;

    return (
        <>
            {COLORS.map((type, index) => {
                return (
                    <StyleColorButton
                        index={index}
                        key={type.label}
                        active={currentStyle?.has(type.style)}
                        label={type.label}
                        onToggle={onToggle}
                        style={type.style}
                    />
                );
            })}
        </>
    );
}
